import React, { lazy } from 'react';
import { useForm } from 'react-hook-form';
import {
  ChangePasswordRequest,
  OrganizationUser,
} from '@enview/interface/types/OrganizationUser';
import { useSelector } from 'react-redux';
import { loadOrgUserError } from '../../dux';
import { OrganizationUserAPI } from '../../api';
const PasswordStrength = lazy(() => import('../Shared/Forms/Account/PasswordStrength'));
import { PASSWORD_MIN_LENGTH } from '../../utils/constants';

const PasswordChange = (props: { organizationUser: OrganizationUser }) => {
  const { organizationUser } = props;
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { register, handleSubmit, errors, watch, setValue } = useForm();

  const [changePassword, { isSuccess, error }] =
    OrganizationUserAPI.endpoints.changePassword.useMutation();

  const onSubmit = async (formData: ChangePasswordRequest): Promise<void> => {
    const request = {
      firstName: organizationUser.firstName,
      lastName: organizationUser.lastName,
      email: organizationUser.email,
      currentPassword: formData.currentPassword,
      newPassword: formData.newPassword,
      passwordConfirm: formData.passwordConfirm,
    };
    await changePassword(request);
    setValue('currentPassword', '');
  };

  const loadingOrgUserError = useSelector(loadOrgUserError);

  const passwordUpdateMsg = loadingOrgUserError
    ? `${loadingOrgUserError.message}`
    : 'Password Updated';

  return (
    <div className="change-password">
      <form className="form registration-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-section-header">Change Password</div>
        {isSuccess && (
          <div className="alert alert-success" role="alert">
            {passwordUpdateMsg}
          </div>
        )}
        {error && (
          <div className="alert alert-warning" role="alert">
            {(error as { data: { message: string } })?.data?.message}
          </div>
        )}
        <div className="field-header">Password</div>
        <div className="row">
          <input
            className="form-control form-field"
            name="currentPassword"
            placeholder="Current Password"
            ref={register({
              required: 'Enter your current password',
            })}
            type="password"
          />
          {errors.currentPassword && (
            <div className="error alert alert-danger">
              {errors?.currentPassword?.message}
            </div>
          )}
          <input
            className="form-control form-field"
            name="newPassword"
            placeholder={`New Password (at least ${PASSWORD_MIN_LENGTH} characters)`}
            ref={register({
              required: 'Please complete this field.',
              minLength: {
                value: PASSWORD_MIN_LENGTH,
                message: `Password must be a minimum of ${PASSWORD_MIN_LENGTH} characters`,
              },
            })}
            type="password"
          />
          {errors.newPassword && (
            <div className="error alert alert-danger">
              {errors?.newPassword?.message}
            </div>
          )}

          <input
            className="form-control form-field"
            name="passwordConfirm"
            placeholder="Confirm password"
            ref={register({
              validate: (value) => value === watch('newPassword'),
            })}
            type="password"
          />
        </div>

        <PasswordStrength password={watch('newPassword')} />
        {errors.passwordConfirm && (
          <div className="error alert alert-danger">Passwords do not match.</div>
        )}
        <div className="submit">
          <button className="btn btn-primary w-100" id="password-submit" type="submit">
            Change Password
          </button>
        </div>
      </form>
    </div>
  );
};

export default PasswordChange;
